<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item active" aria-current="page">
      <a [routerLink]="'/site/sites'">Sites</a>
    </li>
    <li class="breadcrumb-item" aria-current="page">
      @if (isCreate()) {
        <span class="fs-5 fw-bold mb-0">Add site</span>
      }
      @if (!isCreate()) {
        <span class="fs-5 fw-bold mb-0">Edit site</span>
      }
    </li>
  </ol>
</nav>

@if (loaded) {
  <div class="card border-0 shadow mb-3 fade-in-zoom">
    <div class="card-body">
      <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
        <div class="row g-3 mb-3">
          <div class="col">
            <label for="product" class="form-label">Brand</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-box"></i></span>
              <select id="product" class="form-select" formControlName="productId">
                <option [ngValue]="null" disabled>Select product</option>
                @for (product of products; track product) {
                  <option [ngValue]="product.id">{{ product }}</option>
                }
              </select>
            </div>
          </div>
          <div class="col">
            <label class="form-label">Name</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi bi-tag"></i></span>
              <input type="text" class="form-control" placeholder="Name" formControlName="name">
            </div>
          </div>
          <div class="col">
            <label for="domain" class="form-label">Domain</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-link-45deg"></i></span>
              <input type="url" class="form-control" id="domain" placeholder="Enter domain"
                formControlName="domain">
            </div>
          </div>
        </div>
        <div class="row g-3 mb-3">
          <div class="col-6">
            <label for="url" class="form-label">URL</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-link-45deg"></i></span>
              <input type="url" class="form-control" id="url" placeholder="Enter URL"
                formControlName="url">
            </div>
          </div>
          <div class="col-6">
            <label class="form-label fw-bold small">Language</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-translate"></i></span>
              <app-dropdown-select formControlName="lang">
                <app-dropdown-select-option [value]="null">No language</app-dropdown-select-option>
                @for (lang of languages; track lang) {
                  <app-dropdown-select-option [value]="lang.isoCode">
                    <img [ngSrc]="langService.getLanguageFlag(lang)" [alt]="lang.name" class="country-flag"
                      width="24" height="24">
                    {{ lang.name }}
                  </app-dropdown-select-option>
                }
              </app-dropdown-select>
            </div>
          </div>
        </div>
        <div class="row g-3 mb-3">
          <div class="col-6">
            <label for="companyName" class="form-label">Company name</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-link-45deg"></i></span>
              <input type="text" class="form-control" id="companyName" placeholder="Enter company name"
                formControlName="companyName">
            </div>
          </div>
          <div class="col-6">
            <label for="companyCountry" class="form-label">Company country</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-flag"></i></span>
              <select id="companyCountry" class="form-select" formControlName="companyCountry">
                <option [value]="null" disabled>Select country</option>
                @for (country of countries; track country) {
                  <option [value]="country.isoCode">{{ country.name }}</option>
                }
              </select>
            </div>
          </div>
        </div>
        <div class="row g-3 mb-3">
          <div class="col-6">
            <label for="companyAddress" class="form-label">Company address</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-link-45deg"></i></span>
              <input type="text" class="form-control" id="companyAddress" placeholder="Enter company address"
                formControlName="companyAddress">
            </div>
          </div>
          <div class="col-6">
            <label for="companyPostalCode" class="form-label">Company postal code</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-link-45deg"></i></span>
              <input type="text" class="form-control" id="companyPostalCode" placeholder="Enter company address"
                formControlName="companyPostalCode">
            </div>
          </div>
        </div>
        <div class="row g-3 mb-3">
          <div class="col-4">
            <label for="companyRegistrationNumber" class="form-label">Registration number</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-link-45deg"></i></span>
              <input type="text" class="form-control" id="companyRegistrationNumber"
                placeholder="Enter registration number"
                formControlName="companyRegistrationNumber">
            </div>
          </div>
          <div class="col-4">
            <label for="companyEuVatNumber" class="form-label">VAT number (EU)</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-link-45deg"></i></span>
              <input type="text" class="form-control" id="companyEuVatNumber" placeholder="Enter VAT number (EU)"
                formControlName="companyEuVatNumber">
            </div>
          </div>
          <div class="col-4">
            <label for="companyGbVatNumber" class="form-label">VAT number (GB)</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-link-45deg"></i></span>
              <input type="text" class="form-control" id="companyGbVatNumber" placeholder="Enter VAT number (GB)"
                formControlName="companyGbVatNumber">
            </div>
          </div>
        </div>
        <div class="row g-3 mb-3">
          <div class="col-md-4">
            <label for="gtm" class="form-label">Google Tag Manager</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-link-45deg"></i></span>
              <input type="text" class="form-control" id="gtm" placeholder="Google Tag Manager"
                formControlName="gtm">
            </div>
          </div>
          <div class="col-md-4">
            <label for="contactEmail" class="form-label">Contact email</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-link-45deg"></i></span>
              <input type="text" class="form-control" id="contactEmail" placeholder="Contact email"
                formControlName="contactEmail">
            </div>
          </div>
          <div class="col-md-4">
            <label for="dpoEmail" class="form-label">DPO email</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-link-45deg"></i></span>
              <input type="text" class="form-control" id="dpoEmail" placeholder="DPO email"
                formControlName="dpoEmail">
            </div>
          </div>
        </div>
        <div class="row g-3 mb-3">
          <div class="col-6">
            <label for="termsUrl" class="form-label">Terms URL</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-link-45deg"></i></span>
              <input type="url" class="form-control" id="termsUrl" placeholder="Enter terms URL"
                formControlName="termsUrl">
            </div>
          </div>
          <div class="col-6">
            <label for="privacyUrl" class="form-label">Privacy policy URL</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-link-45deg"></i></span>
              <input type="url" class="form-control" id="privacyUrl" placeholder="Enter privacy policy URL"
                formControlName="privacyUrl">
            </div>
          </div>
        </div>
        <div class="row g-3 mb-3">
          <div class="col-6">
            <label for="cookieUrl" class="form-label">Cookies URL</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-link-45deg"></i></span>
              <input type="url" class="form-control" id="cookieUrl" placeholder="Enter cookies URL"
                formControlName="cookieUrl">
            </div>
          </div>
          <div class="col-6">
            <label for="contactUrl" class="form-label">Contact URL</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-link-45deg"></i></span>
              <input type="url" class="form-control" id="contactUrl" placeholder="Enter contact URL"
                formControlName="contactUrl">
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-6">
            <label for="partnerId" class="form-label">Default Partner</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-flag"></i></span>
              <select id="partnerId" class="form-select" formControlName="partnerId">
                <option [value]="null" disabled>Select default partner</option>
                @for (partner of partners; track partner) {
                  <option [value]="partner.id">{{ partner }}</option>
                }
              </select>
            </div>
          </div>
          <div class="col-6">
            <label for="offerId" class="form-label">Default Offer</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-flag"></i></span>
              <select id="offerId" class="form-select" formControlName="offerId">
                <option [value]="null" disabled>Select default offer</option>
                @for (offer of offers; track offer) {
                  <option [value]="offer.id">{{ offer }}</option>
                }
              </select>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-xxl-6">
            <label for="p2" class="form-label">P2 (Above) - Non-GDPR</label>
            <app-product-priority-selector id="p2" formControlName="productP2" [lang]="site?.lang ?? null"></app-product-priority-selector>
          </div>
          <div class="col-xxl-6">
            <label for="p2-gdpr" class="form-label">P2 (Above) - GDPR</label>
            <app-product-priority-selector id="p2-gdpr" formControlName="productP2Gdpr" [priorityList]="false" [lang]="site?.lang ?? null"></app-product-priority-selector>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-xxl-6">
            <label for="p2alt" class="form-label">P2 (Below) - Non-GDPR</label>
            <app-product-priority-selector id="p2alt" formControlName="productP2Alt" [lang]="site?.lang ?? null"></app-product-priority-selector>
          </div>
          <div class="col-xxl-6">
            <label for="p2alt-gdpr" class="form-label">P2 (Below) - GDPR</label>
            <app-product-priority-selector id="p2alt-gdpr" formControlName="productP2AltGdpr" [priorityList]="false" [lang]="site?.lang ?? null"></app-product-priority-selector>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-xxl-6">
            <label for="xsell" class="form-label">XSELL - Non-GDPR</label>
            <app-product-priority-selector id="xsell" formControlName="productCross" [lang]="site?.lang ?? null"></app-product-priority-selector>
          </div>
          <div class="col-xxl-6">
            <label for="xsell-gdpr" class="form-label">XSELL - GDPR</label>
            <app-product-priority-selector id="xsell-gdpr" formControlName="productCrossGdpr"  [lang]="site?.lang ?? null"></app-product-priority-selector>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-xxl-6">
            <label for="slide" class="form-label">Slide - Non-GDPR</label>
            <app-product-priority-selector id="slide" formControlName="productSlide" [lang]="site?.lang ?? null"></app-product-priority-selector>
          </div>
          <div class="col-xxl-6">
            <label for="slide-gdpr" class="form-label">Slide - GDPR</label>
            <app-product-priority-selector id="slide-gdpr" formControlName="productSlideGdpr" [lang]="site?.lang ?? null"></app-product-priority-selector>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="row">
              <div class="col"></div>
              <div class="col-auto">
                <app-input-switch id="enabled" formControlName="enabled">Enabled</app-input-switch>
              </div>
            </div>
          </div>
          <div class="col-auto text-end">
            <button type="submit" class="btn btn-primary fw-bold" [disabled]="!canUpdate()">
              @if (isCreate()) {
                <span>Create</span>
              }
              @if (!isCreate()) {
                <span>Update</span>
              }
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
}
